import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import { injectable, inject } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcher } from '@dm-portal/json-rpc-dispatcher';
import DITypes from '@dm-portal/dm-portal-json-rpc-dispatcher/DITypes';
import withCache from '@framework/with-cache';

@injectable()
class TransactionTypeRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) private rpc: IDispatcher,
  ) {}

  @withCache
  async getTransactionTypeList(tenant: string) {
    const request = new Request('dm_portal.market.transaction_type.get_list', {
      tenant,
    });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  }
}

export default TransactionTypeRepository;
